import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      const dest = location.state?.from || "/dashboard";
      nav(dest);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12 bg-grain">
      <Card className="w-full max-w-md p-8 shadow-xl">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-heading font-bold">Tutor sign in</h1>
          <p className="text-sm text-muted-foreground mt-1">Manage your profile and incoming requests.</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="l-email">Email</Label>
            <Input
              id="l-email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="tutor-login-email-input"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="l-pw">Password</Label>
            <Input
              id="l-pw"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="tutor-login-password-input"
            />
          </div>
          <Button
            type="submit"
            disabled={submitting}
            className="w-full rounded-full h-11"
            data-testid="tutor-login-submit-button"
          >
            {submitting ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <p className="text-sm text-muted-foreground text-center mt-5">
          New to Tutors Paradise?{" "}
          <Link to="/register" className="text-primary font-medium link-underline">
            Create a tutor account
          </Link>
        </p>
      </Card>
    </div>
  );
}
